import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  // measurementId: "${config.measurementId}"
};

const app = initializeApp(firebaseConfig);
export default app;
export const auth = getAuth(app);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
// console.log(analytics);
// console.log(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID)

export async function getAboutMeData() {
  const docRef = doc(db, "Elemento", "AboutMe");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
export async function getHeaderData() {
  const docRef = doc(db, "Elemento", "Header");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
export async function getResumeData() {
  const docRef = doc(db, "Elemento", "Resume");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
export async function getProjectsData() {
  const docRef = doc(db, "Elemento", "Projects");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
export async function getCertificationsData() {
  const docRef = doc(db, "Elemento", "Certifications");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
export async function getThemeData() {
  const docRef = doc(db, "Elemento", "Themes");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    // console.log( docSnap.data());
    return docSnap.data();
  } else {
    console.log("No such document!");
  }
}
